import { render, staticRenderFns } from "./CampusCreate.vue?vue&type=template&id=610f220e"
import script from "../../controllers/campus/campus-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus/campus-create.js?vue&type=script&lang=js&external"
import style0 from "./CampusCreate.vue?vue&type=style&index=0&id=610f220e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports